











import { Component, Vue,Prop } from 'vue-property-decorator'
import {MDCTabBar} from '@material/tab-bar'
@Component({})
export default class MdcTopAppBar extends Vue{
  mdcComponent!:MDCTabBar
  _activateListener =(e:Event)=>this._activate(e)
  _activate(e:Event){
    console.log('activate',e)
  }
  mounted() {
    const root =(this.$refs.root as HTMLElement)
    root.addEventListener('MDCTabBar:activated',this._activateListener)
    this.mdcComponent = new MDCTabBar(root)
    console.log('mouted')
  }
  beforeDestroy() {
    const root =(this.$refs.root as HTMLElement)
    root.removeEventListener('MDCTabBar:activated',this._activateListener)
    this.mdcComponent.destroy()
  }
}
